import React, { FC, ReactElement } from 'react';
import { Chip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  label: string;
  onDelete: () => void;
  avatar?: ReactElement;
}

const FilterChip: FC<Props> = ({ avatar, label, onDelete }) => {
  return (
    <Chip
      clickable
      variant="outlined"
      label={label}
      avatar={avatar}
      deleteIcon={<CloseIcon fontSize="small" />}
      onDelete={onDelete}
    />
  );
};

export default FilterChip;
